<template>
  <div class="topnav">
    <div class="search-container">
      <!-- <input
        type="text"
        placeholder="Search.."
        name="search"
        v-model="search"
        class="searchbar"
      /> -->
      <!-- {{ filterData }} -->
      <div class="rounded-xl mb-2">
        <!-- <DiscoverCard /> -->

        <Post
          v-for="(item, index) in posts"
          :key="'item-' + index"
          :item="item"
        />

        <NoMorePosts
          :text="noResultText"
          v-if="!posts.length && ChannelList.length > 0"
        />
        <!-- <Discussion
          v-for="(item, index) in discussion"
          :key="'discussion-' + index"
          :item="item"
        /> -->

        <!-- <Poll
          v-for="(item, index) in posts"
          :key="'poll-' + index"
          :data="item"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import Post from "./Post";
import Discussion from "./Discussion.vue";
import Poll from "./Poll.vue";
import DiscoverCard from "./DiscoverCard.vue";
import NoMorePosts from "./NoMorePosts";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    Post,
    Discussion,
    Poll,
    DiscoverCard,
    NoMorePosts,
  },
  data() {
    return {
      discussion: [
        {
          userImg:
            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
          userName: "John Doe",
          postDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          discussDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        {
          userImg:
            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
          userName: "John Doe",
          postDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          discussDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          postImg: require("../img/post4.png"),
        },
      ],
      poll: [
        {
          userImg:
            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
          userName: "John Doe",
          postDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          discussDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna al incididunt ut labore et dolore magna",
          polloption1: "Option A",
          polloption2: "Option B",
          polloption3: "Option C",
          polloption4: "Option D",
        },
      ],
      noResultText: "Be the first to upload a new post",
      search: "",
    };
  },
  methods: {
    test() {
      // console.log(this.posts);
    },
  },

  mounted() {
    this.test();
  },
  computed: {
    ...mapState("posts", ["posts"]),
    ...mapGetters("channel", { ChannelList: "currentUserChannel" }),

    filterData() {
      return this.posts.filter((item) => {
        if (item["text"]) {
          return item.text.includes(this.search);
        }
      });
    },
    // PollData() {
    //   return this.poll.filter((item) => {
    //     if (item["poll"]) {
    //       return item.poll.includes(this.search);
    //     }
    //   });
    // },
  },
};
</script>
